import { Grid } from '@mui/material';
import { deleteUserRoleApi, getAllInstUsersApi, getUserByRoleIdAndInstApi, getUserByRoleIdAndInstArrayApi, postSaveUserRoleApi } from 'api/user';
import { getUserFullName, swal_error } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import UserCustomDataTable from '../user/UserCustomDataTable';

import RoleListDialog from 'app/components/Dialog/RoleListDialog';
import RoleUserList from 'app/components/List/RoleUserList';
import LoadingPopUp from 'app/components/LoadingPopup';
import Swal from 'sweetalert2';

const RoleManagementPage = () => {

  const params = useParams();
  const param = params.pageType;
  const [loading, setLoading] = useState(true);
  const hightCoordinator = useSelector(state => state.auth.authUser);
  const [userList, setUserList] = useState([]);
  const [unitMeetingManagerList, setUnitMeetingManagerList] = useState([]);
  const [instManagerList, setInstManagerList] = useState([]);
  const [instReadingMenagerList, setInstReadingMenagerList] = useState([]);
  const [ykinstManagerList, setYkinstManagerList] = useState([]);
  const [ykinstReadingMenagerList, setYkinstReadingMenagerList] = useState([]);
  const [ykUnitManagerList, setYkUnitManagerList] = useState([]);
  const [ykReadingManagerList, setYkReadingManagerList] = useState([]);
  const [selectedInst, setSelectedInst] = useState();
  const [inst, setInst] = useState([]);
  const authUser = useSelector(state => state.auth.authUser);
  const [selectedUser, setSelectedUser] = useState(false);
  const [roleDialogStatus, setRoleDialogStatus] = useState(false);
  const unitList = useSelector(state => state.unit.data || []);
  const [showKurulList, setShowInstList] = useState(false);
  const [showYKList, setShowYKList] = useState(false);
  const [showYKReadingList, setShowYKReadingList] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const [usersRoleList, setUsersRoleList] = useState([]);
  const [loadingProcess, setLoadingProcess] = useState(false);
  const [isSuperUser, setIsSuperUser] = useState(false);
  useEffect(() => {

    if (loading === false) {
      setLoading(true);
    }
  }, [param]);



  useEffect(() => {

    const getAPI = async () => {

      let instList = [];
      setLoading(true)

      const userRoles = hightCoordinator.userRoles;

      const superUser = userRoles.filter(x => x.id === 1);
      setIsSuperUser(superUser.length > 0);
      const instAdminRole = userRoles.filter(x => x.id === 373); // kurul yon
      const ykinstAdminRole = userRoles.filter(x => x.id === 370); // yk yon

      const resultUserList = await getAllInstUsersApi();

      setUserList(resultUserList.data.filter(x => x.roleId !== 1))

      if (superUser !== undefined && superUser.length > 0) {

        const resultInstManager = await getUserByRoleIdAndInstApi(373, "all");
        const resultInstReadingManager = await getUserByRoleIdAndInstApi(368, "all");
        const resultMeetingManager = await getUserByRoleIdAndInstApi(369, "all");

        const ykresultInstManager = await getUserByRoleIdAndInstApi(370, "all");
        const ykresultInstReadingManager = await getUserByRoleIdAndInstApi(371, "all");
        const ykresultReadingManager = await getUserByRoleIdAndInstApi(418, "all");

        const ykresultMeetingManager = await getUserByRoleIdAndInstApi(372, "all");
        setYkUnitManagerList(ykresultMeetingManager.data)
        setYkReadingManagerList(ykresultReadingManager.data)
        setInstManagerList(resultInstManager.data)
        setInstReadingMenagerList(resultInstReadingManager.data)
        setUnitMeetingManagerList(resultMeetingManager.data)

        setYkinstManagerList(ykresultInstManager.data)
        setYkinstReadingMenagerList(ykresultInstReadingManager.data)

        setShowInstList(true);
        setShowYKList(true);
        // 418 rolü sadece 370 ve 1 rolüne sahip kullanıcılar tarafından görülebilir
        if (superUser.length > 0 || ykinstAdminRole.length > 0) {
          setShowYKReadingList(true);
        }
      } else {

        if (instAdminRole !== undefined && instAdminRole.length > 0) {

          instList.push(...instAdminRole.map(item => item.inst));

          const resultInstManager = await getUserByRoleIdAndInstArrayApi(373, instList);  // hata verdi kaldımmm
          const resultInstReadingManager = await getUserByRoleIdAndInstArrayApi(368, instList);
          const resultMeetingManager = await getUserByRoleIdAndInstArrayApi(369, instList);

          setInstManagerList(resultInstManager.data)
          setInstReadingMenagerList(resultInstReadingManager.data)
          setUnitMeetingManagerList(resultMeetingManager.data)

          setShowInstList(true);

          if (isSuperUser === false) {
            let ykresultReadingManager = await getUserByRoleIdAndInstApi(418, "all");
            ykresultReadingManager = ykresultReadingManager.data.filter(x => x.inst === instAdminRole[0].inst);
            setYkReadingManagerList(ykresultReadingManager)
            // setShowYKReadingList(true);
          }




        }

        if (ykinstAdminRole !== undefined && ykinstAdminRole.length > 0) {

          instList.push('YK');

          const ykresultInstManager = await getUserByRoleIdAndInstApi(370, 'YK');  // hata verdi kaldımmm
          const ykresultInstReadingManager = await getUserByRoleIdAndInstApi(371, 'YK');

          setYkinstManagerList(ykresultInstManager.data)
          setYkinstReadingMenagerList(ykresultInstReadingManager.data)
          const ykresultReadingManager = await getUserByRoleIdAndInstApi(418, "all");
          setYkReadingManagerList(ykresultReadingManager.data)

          const ykresultMeetingManager = await getUserByRoleIdAndInstApi(372, "all");
          setYkUnitManagerList(ykresultMeetingManager.data)

          setShowYKList(true);
          // 418 rolü sadece 370 ve 1 rolüne sahip kullanıcılar tarafından görülebilir
          // if (superUser.length > 0 || ykinstAdminRole.length > 0) {
          //   setShowYKReadingList(true);
          // }

          setShowYKReadingList(true);
        }




      }

      setInst(instList)


      // else if (unitMeetingRole !== undefined) { // sadece 369lari gorecek
      //   const resultMeetingManager = await getUserByRoleIdAndInstApi(369, "all");
      //   setUnitMeetingManagerList(resultMeetingManager.data)
      // } 


      setLoading(false)

    }
    getAPI();
  }, [])

  const handleDeleteCoordinatorRole = async (roleId, user) => { // unitsiz 368 ve 373 için

    Swal.fire({
      title: 'Rol Silme İşlemi',
      text: "Rolü silmek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {

      if (result.isConfirmed) {

        setLoadingProcess(true)
        result = await deleteUserRoleApi({ id: user.userRoleId })

        if (result.status) {


          if (roleId === 373) {
            const filteredList = instManagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );
            setInstManagerList(filteredList);

          } else if (roleId === 368) {

            const filteredList = instReadingMenagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );

            setInstReadingMenagerList(filteredList);
          }
          else if (roleId === 369) {

            const filteredList = unitMeetingManagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );
            setUnitMeetingManagerList(filteredList);
          }

          if (roleId === 370) {
            const filteredList = ykinstManagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );
            setYkinstManagerList(filteredList);

          } else if (roleId === 371) {

            const filteredList = ykinstReadingMenagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );

            setYkinstReadingMenagerList(filteredList);
          } else if (roleId === 372) {

            const filteredList = ykUnitManagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );
            setYkUnitManagerList(filteredList);
          } else if (roleId === 418) {

            const filteredList = ykReadingManagerList.filter(x =>
              !(x.userRoleId === user.userRoleId)
            );
            setYkReadingManagerList(filteredList);
          }


        }

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Silme işlemi başarılı.',
          showConfirmButton: false,
          timer: 1500
        });
        setLoadingProcess(false)

      }
    })

  }


  const roleAddCheck = (roleId, unitId, user, inst) => {

    if (roleId === 373) {
      const isThere = instManagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }

    if (roleId === 368) {

      const isThere = instReadingMenagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }

    if (roleId === 369) {
      const isThere = unitMeetingManagerList.some(x => x.id === user.id && x.customId === unitId)
      return isThere
    }

    if (roleId === 370) {
      const isThere = ykinstManagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }

    if (roleId === 371) {
      const isThere = ykinstReadingMenagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }

    if (roleId === 418) {
      const isThere = ykReadingManagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }

    return false
  }

  const roleUnitAddCheck = (roleId, unitId, user, inst) => {

    if (roleId === 369) {
      const isThere = instManagerList.some(x => x.id === user.id && x.roleInst === inst)
      // const isThere = unitMeetingManagerList.some(x => x.id === user.id && x.customId === unitId)
      return isThere
    }

    if (roleId === 372) {
      const isThere = ykUnitManagerList.some(x => x.id === user.id && x.roleInst === inst)
      return isThere
    }



    return false
  }

  const handleCloseRole = async (roleId, inst, unitId = 0) => {
    if (roleId === false || !roleId || roleId === undefined || unitId === null) {
      setRoleDialogStatus(false);
      return;
    }


    if (roleId !== undefined) {


      Swal.fire({
        title: 'Rol Ekleme İşlemi',
        text: "Rolü eklemek istediğinizden emin misiniz?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet Ekle',
        cancelButtonText: "Vazgeç"
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoadingProcess(true)
          if (roleUnitAddCheck(roleId, unitId, selectedUser, inst)) {

            swal_error(`${inst}` + " kuruma ait tüm birimlerde yetkiye sahiptir.", 2500)
            handleDialogClose();
          } else if (roleAddCheck(roleId, unitId, selectedUser, inst)) {

            swal_error("Bu rol önceden verilmiş.")
            handleDialogClose();
          }
          else {

            const result = await postSaveUserRoleApi({ userId: selectedUser.id, roleId, inst, customId: unitId, addedUserId: authUser.id, addedDate: new Date() })
            selectedUser.roleInst = inst;
            selectedUser.userRoleId = result.userRole.id;

            if (unitId !== 0) {
              selectedUser.customId = unitId;

            }

            if (result.status) {


              if (roleId === 373) {
                const updatedList = [selectedUser, ...instManagerList];
                setInstManagerList(updatedList)

              }
              else if (roleId === 368) {

                setInstReadingMenagerList(prevInstReadingMenagerList => [selectedUser, ...prevInstReadingMenagerList]);

              }
              else if (roleId === 369) {
                const unit = unitList.find(x => x.id === unitId);
                const newUser = { ...selectedUser, unitName: unit.name, customId: unitId };
                setUnitMeetingManagerList(prev => [newUser, ...prev]);
              }
              if (roleId === 370) {
                const updatedList = [selectedUser, ...ykinstManagerList];
                setYkinstManagerList(updatedList)

              }
              else if (roleId === 371) {

                setYkinstReadingMenagerList(prevYkinstReadingMenagerList => [selectedUser, ...prevYkinstReadingMenagerList]);

              }
              else if (roleId === 372) {
                const unit = unitList.find(x => x.id === unitId);
                const newUser = { ...selectedUser, unitName: unit.name, customId: unitId };
                setYkUnitManagerList(prev => [newUser, ...prev]);
              }
              else if (roleId === 418) {
                setYkReadingManagerList(prevYkReadingManagerList => [selectedUser, ...prevYkReadingManagerList]);
              }
              // 372 YAPILMADI 

              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'İşlem başarılı.',
                showConfirmButton: false,
                timer: 1500
              });

              handleDialogClose(); // Dialogu kapatır
              setLoadingProcess(false)
            }
          }

        } else {
          handleDialogClose(); // Dialogu kapatır


        }
      })
    }

  };


  const handleDialogClose = () => {
    setRoleDialogStatus(false);
  };

  const columnData = [
    { id: 'id', align: 'center', disablePadding: false, label: 'Resim' },
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'center', disablePadding: false, label: 'İşlemler' },
  ];



  useEffect(() => {
    const list = unitMeetingManagerList.filter(x => x.id === selectedUser.id)
    const ykList = ykUnitManagerList.filter(x => x.id === selectedUser.id)
    const ykReadingList = ykReadingManagerList.filter(x => x.id === selectedUser.id)
    setUsersRoleList([...list, ...ykList, ...ykReadingList]);
    setPageTitle(getUserFullName(selectedUser));

  }, [selectedUser])


  return (

    <div>
      <LoadingPopUp open={loading} />
      {!loading && (
        <>
          <Grid container >
            <Grid container spacing={3.75}>

              <Grid item xs={12} sm={12} lg={12}>
                <LoadingPopUp open={loadingProcess} />
              </Grid>

              <Grid item xs={12} sm={6} lg={5} >

                <UserCustomDataTable mainData={userList} column={columnData} pageTitle="Kullanıcı Listesi" setSelectedUser={setSelectedUser} setRoleDialogStatus={setRoleDialogStatus} />

              </Grid>

              <Grid item xs={12} sm={12} lg={7} >
                <Grid container spacing={3.75}>

                  {showKurulList === true ? (
                    <>
                      <Grid item xs={12} sm={12} lg={4}>
                        <RoleUserList
                          key={instManagerList.length}
                          title={'Kurum Yöneticileri Listesi'}
                          userList={instManagerList}
                          selectedUser={selectedUser}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(373, user)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} lg={4}>
                        <RoleUserList
                          key={instReadingMenagerList.length}
                          title={'Kurum Yöneticileri Okuma Listesi'}
                          userList={instReadingMenagerList}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(368, user)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} lg={4}>
                        <RoleUserList
                          key={unitMeetingManagerList.length}
                          role={369}
                          title={'Toplantı Yöneticileri Listesi'}
                          userList={unitMeetingManagerList}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(369, user)}
                        />
                      </Grid>


                      {isSuperUser === false && showYKReadingList === true ? (
                        <Grid item xs={12} sm={12} lg={4}>
                          <RoleUserList
                            key={ykReadingManagerList.length}
                            title={'Yönetim Kurulu Okuma Rolü Listesi'}
                            userList={ykReadingManagerList}
                            handleDeleteUser={(user) => handleDeleteCoordinatorRole(418, user)}
                          />
                        </Grid>
                      ) : null}

                    </>
                  ) : null}



                  {showYKList === true ? (
                    <>
                      <Grid item xs={12} sm={12} lg={4}>
                        <RoleUserList
                          key={ykinstManagerList.length}
                          title={'YK Yöneticileri Listesi'}
                          userList={ykinstManagerList}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(370, user)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} lg={4}>

                        <RoleUserList
                          key={ykinstReadingMenagerList.length}
                          title={'YK Yöneticileri Okuma Listesi'}
                          userList={ykinstReadingMenagerList}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(371, user)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} lg={4}>
                        <RoleUserList
                          role={372}
                          key={ykUnitManagerList.length}
                          title={'YK Toplantı Yöneticileri Listesi'}
                          userList={ykUnitManagerList}
                          handleDeleteUser={(user) => handleDeleteCoordinatorRole(372, user)}
                        />
                      </Grid>

                      {showYKReadingList === true ? (
                        <Grid item xs={12} sm={12} lg={4}>
                          <RoleUserList
                            key={ykReadingManagerList.length}
                            title={'Yönetim Kurulu Okuma Rolü Listesi'}
                            userList={ykReadingManagerList}
                            handleDeleteUser={(user) => handleDeleteCoordinatorRole(418, user)}
                          />
                        </Grid>
                      ) : null}
                    </>
                  ) : null}








                </Grid>
              </Grid>

            </Grid>
          </Grid>


          <RoleListDialog

            open={roleDialogStatus}
            // onClose={handleCloseRole}
            onClose={handleDialogClose} // Ayırdığımız yeni işlevi kullanıyoruz
            handleCloseRole={handleCloseRole}
            selectedValue={selectedInst}
            setSelectedValue={setSelectedInst}
            inst={inst}
            usersRoleList={usersRoleList}
            pageTitle={pageTitle}
          />
        </>
      )}
    </div>


  )
}

export default RoleManagementPage
